export default "__VITE_ASSET__CunPG8Kz__"